angular.module('core')
	.directive("loadingSpinner", function() {
		return {
			restrict: "E",
			template: '<div class="spinner-container"><div class="spinner"></div></div>',
			controller: ['$scope', '$element', function($scope, $element) {}]
		};
	});
